// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./_layout.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/src/app/_layout.tsx"); } },
  "./e/[slug].tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/src/app/e/[slug].tsx"); } },
  "./e/index.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/src/app/e/index.tsx"); } },
  "./index.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/src/app/index.tsx"); } },
  "./privacy.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/src/app/privacy.tsx"); } },
  "./terms.tsx": { enumerable: true, get() { return require("/opt/buildhome/repo/src/app/terms.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;